export default __webpack_public_path__ + "static/media/manage_role_technician_icon.707d6ec0.svg";